


































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails'
import VerifiableAttribute from '@/components/Shared/VerifiableAttribute.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerSkillCreate from '@/components/WorkerSkills/WorkerSkillCreate.vue';
import WorkerSkillEdit from '@/components/WorkerSkills/WorkerSkillEdit.vue';
import { WorkerSkillDto } from '@/models/Workers/WorkerSkillDto';

@Component({
  name: 'WorkerSkills',
  components: { VerifiableAttribute, WorkerSkillCreate, WorkerSkillEdit }
})
export default class extends GiganautVue {

    deleteDialog = false;
    deleting = false;
    skillToDelete: WorkerSkillDto | null = null;

    async created() {
       await WorkerDetailsModule.getSkills();
    }

    get loading() {
        return WorkerDetailsModule.loadingSkills;
    }

    get skills() {
        return WorkerDetailsModule.skills;
    }

    confirmDelete(skill: WorkerSkillDto) {
        this.skillToDelete = skill;
        this.deleteDialog = true;
    }

    async deleteSkill() {
        if (!this.skillToDelete) return;
        this.deleting = true;
        await WorkerDetailsModule.deleteSkill(this.skillToDelete.id);
        this.deleting = false;
        this.deleteDialog = false;
        this.skillToDelete = null;
    }

}
